import { Injectable } from '@angular/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MsgServiceService {

  opcoes = {
    closeButton: true,
    timeOut: 5000,
    positionClass: 'toast-top-right',
    toastClass: 'ngx-toastr',
    titleClass: 'toast-title',
    messageClass: 'toast-message'
  };

  constructor(public toastr: ToastrService) { }

  msgSucesso(msg: string) {
    this.toastr.success(msg, 'Sucesso!', this.opcoes);
  }

  msgErro(msg: string) {
    this.toastr.error(msg, 'Erro', this.opcoes);
  }

  msgAdvertencia(msg: string) {
    this.toastr.warning(msg, 'Atenção', this.opcoes);
  }

  msgInfo(msg: string) {
    this.toastr.info(msg, 'Info', this.opcoes);
  }

}
